import { Skeleton } from 'antd';
import { InlineError } from '../InlineError/InlineError';

type Props = {
  query: { isPending: boolean; error: Error | null };
  /** Capitalized record name, e.g. "Idea". */
  entity: string;
};

/** Drawer body shown while a record query is loading, failed, or came back empty. */
export const DrawerQueryStatus = ({ query, entity }: Props) => (
  <div style={{ padding: 24 }}>
    {query.isPending ? (
      <Skeleton active paragraph={{ rows: 6 }} />
    ) : query.error ? (
      <InlineError title={`Couldn't load ${entity.toLowerCase()}`} detail={query.error.message} />
    ) : (
      <InlineError title={`${entity} not found`} detail="It may have been removed or you used a stale link." />
    )}
  </div>
);
